module.exports = __webpack_public_path__ + "static/media/alert-success.b5c9f8ff.svg";